import styled from 'styled-components';
import { mediaBreakpointMixin, ToggleCard } from '@zillow/constellation';

export const StyledToggleCard = styled(ToggleCard)`
  @media ${mediaBreakpointMixin('xl_gte')} {
    max-width: 290px;
  }
`;
